import { render, staticRenderFns } from "./LabelForm.vue?vue&type=template&id=39eecd0b"
import script from "./LabelForm.vue?vue&type=script&lang=js"
export * from "./LabelForm.vue?vue&type=script&lang=js"
import style0 from "./LabelForm.vue?vue&type=style&index=0&id=39eecd0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports